// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const alakazam_mega: PokeData = {
  "id": 10037,
  "name": "alakazam-mega",
  "height": 12,
  "weight": 480,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "disable",
    "psybeam",
    "confusion",
    "psychic",
    "teleport",
    "night-shade",
    "recover",
    "barrier",
    "reflect",
    "kinesis",
    "flash",
    "substitute",
    "encore",
    "future-sight",
    "trick",
    "calm-mind",
    "miracle-eye",
    "psycho-cut",
    "telekinesis",
    "ally-switch"
  ],
  "moves": [
    "psychic",
    "night-shade",
    "reflect",
    "kinesis",
    "future-sight",
    "calm-mind",
    "psy-ball",
    "psy-pulse",
    "psywave",
    "psychic-fangs",
    "prismatic-cage",
    "healing-wish",
    "synchronize"
  ],
  "evolution_chain": {
    "id": 27,
    "item": null,
    "species": [
      {
        "name": "abra",
        "order": 69,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kadabra",
        "order": 70,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 63,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "alakazam",
        "order": 71,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 64,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71,
    "speed": 152,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
